/**
 * Ícones de traço da mesa (DESIGN §13): um único conjunto, 24×24, traço 1,75 e
 * pontas redondas, na cor do texto. Sempre acompanham um rótulo ou um aria-label.
 */
export const MESA_ICON = {
  inicio: 'M4 10.5 12 4l8 6.5V19a1 1 0 0 1-1 1h-4.5v-5.5h-5V20H5a1 1 0 0 1-1-1z',
  agenda:
    'M5 6h14a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zM4 10h16M8 4v4M16 4v4',
  pacientes:
    'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5M16 4.6a3.3 3.3 0 0 1 0 6.2M18 14.8c1.8.7 3 2.5 3 5.2',
  financeiro: 'M4 6.5h16v11H4zM4 10.5h16M8 14.5h3',
  numeros: 'M5 19v-7M10 19V5M15 19v-5M20 19V9',
  ajustes: 'M4 7h9M17 7h3M4 17h3M11 17h9M15 5v4M9 15v4',
  busca: 'M11 4a7 7 0 1 1 0 14 7 7 0 0 1 0-14zM20 20l-4-4',
  mais: 'M12 5v14M5 12h14',
  seguir: 'M9 6l6 6-6 6',
  voltar: 'M15 6l-6 6 6 6',
  certo: 'M5 12.5l4.5 4.5L19 7.5',
  mensagem: 'M5 5h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-8l-5 3.5V17H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1z',
  bolo: 'M5 20h14v-7H5zM5 15.5c2 1.2 3.5 1.2 5 0s3.5-1.2 5 0 3 1.2 4 0M12 9.5V13M12 5.5c.9 1 .9 2 0 2.6-.9-.6-.9-1.6 0-2.6z',
  fechar: 'M6 6l12 12M18 6L6 18',
  anotar: 'M4 20h4L19 9l-4-4L4 16zM14 6l4 4',
  estrela: 'M12 4.5l2.3 4.7 5.2.8-3.8 3.6.9 5.2L12 16.4l-4.6 2.4.9-5.2-3.8-3.6 5.2-.8z',
  funil: 'M4 5h16l-6 7.5V19l-4-2v-4.5z',
  baixar: 'M12 4v11M7 10l5 5 5-5M5 20h14',
  sino: 'M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15zM10 20.5a2 2 0 0 0 4 0',
  tarefa: 'M5 5h14v14H5zM8.5 12l2.5 2.5L15.5 9',
  prato:
    'M12 7a6 6 0 1 1 0 12 6 6 0 0 1 0-12zM12 10a3 3 0 1 1 0 6 3 3 0 0 1 0-6zM3 4v5a2 2 0 0 0 2 2v9M5 4v5M21 4c-1.7 1-2.5 3-2.5 5.5H21V20',
  frasco: 'M9 3h6M10 3v4L6.5 13a5.5 5.5 0 0 0 5.5 8 5.5 5.5 0 0 0 5.5-8L14 7V3M8 14h8',
  /** Halter (treinos do personal). */
  haltere: 'M3 10v4M6 7.5v9M18 7.5v9M21 10v4M6 12h12',
  relogio: 'M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zM12 8v4.5l3 2',
  pessoa: 'M12 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM5 20c0-3.6 3.1-6 7-6s7 2.4 7 6',
  dinheiro:
    'M12 4v16M16 7.5c-.8-1.2-2.2-2-4-2-2.2 0-4 1.1-4 3s1.8 2.6 4 3.2 4 1.3 4 3.3-1.8 3-4 3c-1.9 0-3.4-.8-4.2-2.1',
  prontuario:
    'M8 4h8v3H8zM8 5.5H6a1 1 0 0 0-1 1V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6.5a1 1 0 0 0-1-1h-2M9 11.5h6M9 15h6M9 18.5h3',
  olho: 'M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12zM12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6z',
  discreto:
    'M4 4l16 16M9.9 6A9.7 9.7 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a17 17 0 0 1-2.8 3.6M6.4 7.7A16 16 0 0 0 2.5 12S6 18.5 12 18.5c1.6 0 3-.4 4.2-1M9.9 9.9a3 3 0 0 0 4.2 4.2',
} as const;

export type MesaIconName = keyof typeof MESA_ICON;

export function MesaIcon({
  name,
  size = 18,
  filled = false,
}: {
  name: MesaIconName;
  size?: number;
  /** Preenchido (a estrela marcada). */
  filled?: boolean;
}) {
  return (
    <svg
      className="mesa-ic"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={MESA_ICON[name]} />
    </svg>
  );
}
